import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { ColorConfigurationSelect } from '../inputs/ColorConfigurationSelect';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { PaintColorValue } from '../readonly/PaintColorValue';
import { ConfigurationComponent } from '.';

const PaintColorInsideConfig = () => (
  <ColorConfigurationSelect
    configurationKey="paintColorInside"
    dispatchAction="SET_PAINT_COLOR_INSIDE"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'paintColorInside'> = {
  key: 'paintColorInside',
  input: <PaintColorInsideConfig />,
  display: (value: ConfigurationValues['paintColorInside']) => (
    <PaintColorValue value={value} />
  ),
};

export default config;
